
// This is an auto generated file - do not edit!
// Swagger path: /api/Import/type/{typeCode}

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import {
    Import
} from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class ImportTypeTypecodeApiService extends BaseApiService {
    
    post(typeCode: string, _import: any, options = {}): Observable<Import> {
        return this._post<Import, any>(
            `/Import/type/${typeCode}`,
            _import,
            options
        );
    }
}
